<template>
  <div class="recipes-1__header">
    THE MAGIC IS IN THE MIX
  </div>
  <div class="recipes-1__intro">
    Get inspired for how to make a delicious Pimm’s, whatever the weather. Enjoy&nbsp;responsibly.
  </div>
  <div class="recipes-1">
    <div class="recipes-1__col recipes-1__col--1 pt--50">
      <div class="recipes-1__h1">
        PIMM’S NO.1
      </div>
      <div class="recipes-1__h2">
        A JUG FOR EVERYONE
      </div>
      <div class="recipes-1__ingredients">
        <div class="recipes-1__ingredient">
          FILL A JUG WITH ICE

        </div>
        <div class="recipes-1__ingredient">
          <span class="recipe-1__a cswidget" data-product-sku="764611, 764651, 768819" data-asset-id="2304">1 PART PIMM’S NO.1</span>
        </div>
        <div class="recipes-1__ingredient">
          3 PARTS LEMONADE 
        </div>
      </div>
      <div class="recipes-1__method">
        FINISH WITH SLICES OF STRAWBERRIES, CRISP CUCUMBER, ORANGE WHEELS AND A SPRIG OF&nbsp;MINT.
      </div>
      <div class="recipes-1__cta cswidget" data-product-sku="764611, 764651, 768819" data-asset-id="2304" data-action="csWidgetOpen">
        BUY PIMM’S NO.1
      </div>
      <div class="recipes-1__price">
        FROM £<span class="recipes-1__from"></span>
      </div>
      <img class="recipes-1__img--jug--mobile" src="../.././public/misc/jug.png">
    </div>
    <div class="recipes-1__col recipes-1__col--2">
      <img class="recipes-1__img--serve" src="../.././public/misc/serve.png">
      <img class="recipes-1__img--jug" src="../.././public/misc/jug.png">
    </div>
    <div class="recipes-1__col recipes-1__col--3 pt--50">
      <div class="recipes-1__h1">
        PIMM’S NO.1
      </div>
      <div class="recipes-1__h2">
        A GLASS FOR YOU
      </div>
      <div class="recipes-1__ingredients">
        <div class="recipes-1__ingredient">
          FILL A GLASS WITH ICE

        </div>
        <div class="recipes-1__ingredient">
          <span class="recipe-1__a cswidget" data-product-sku="764611, 764651, 768819" data-asset-id="2304">
            50ML PIMM’S NO.1
          </span>
        </div>
        <div class="recipes-1__ingredient">
          150ML LEMONADE
        </div>
        <div class="recipes-1__ingredient">
          (1.3 UNITS PER SERVE) 
        </div>
      </div>
      <div class="recipes-1__method">
        FINISH WITH SLICES OF STRAWBERRIES, CRISP CUCUMBER, ORANGE WHEELS AND A SPRIG OF&nbsp;MINT.
      </div>
      <div class="recipes-1__cta cswidget" data-product-sku="764611, 764651, 768819" data-asset-id="2304" data-action="csWidgetOpen">
        BUY PIMM’S NO.1
      </div>
      <div class="recipes-1__price">
        FROM £<span class="recipes-1__from"></span>
      </div>
      <img class="recipes-1__img--serve--mobile" src="../.././public/misc/serve.png">
    </div>
  </div>
  <div class="stripes">
    <div class="stripe"></div>
    <div class="stripe"></div>
    <div class="stripe"></div>
  </div>
</template>
<script setup>
import gsap from 'gsap';
import dataModel from "../js/model.js";
const props = defineProps({
  brandExperience: {
    type: String,
    default: "1",
  }
});

$(document).ready(function() {
  $('.recipes-1__from').html(dataModel[1].retailers[1].price)
  
  
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.recipes-1__header {
  color: $color--gold;
  font-size: 60px;
  line-height: 64px;
  @media screen and(max-width: 767px) {
    font-size: 34px;
    line-height: 34px;
    padding: 0px 20px;
  }
}
.recipes-1__intro {
  color: #222222;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  padding-bottom: 50px;
  text-transform: none;
  @media screen and(max-width: 767px) {
    padding: 0px 20px;
    padding-top: 20px;
  }
}
.recipes-1 {
  @include flexbox();
  @include align-items(flex-start);
  @include justify-content(center);
  margin: auto;
  max-width: 960px;
  position: relative;
  width: 100%;
  @media screen and(max-width: 768px) {
    @include flex-direction(column);
  }

}
.recipes-1__col {
  @include flexbox();
  @include align-items(center);
  @include justify-content(flex-start);
  @include flex-direction(column);
  height: 100%;
  max-width: 320px;
  position: relative;
  width: 100%;
  @media screen and(max-width: 768px) {
    max-width: none;
  }
}
.recipes-1__col--1 {
  @media screen and(max-width: 768px) {
    @include align-self(flex-start);
    padding-left: 20px;
    text-align: left;
    width: 200px;
    & > div {
      width: 100%;
    }
  }
}
.recipes-1__col--3 {
  @media screen and(max-width: 768px) {
    @include align-self(flex-end);
    padding-right: 20px;
    padding-bottom: 100px;
    text-align: right;
    width: 200px;
    & > div {
      width: 100%;
    }
  }
}
.recipes-1__col--2 {
  @media screen and(max-width: 768px) {
    display: none;
  }
}
.recipes-1__h1 {
  color: $color--red;
  font-weight: 700;
  font-size: 36px;
  line-height: 30px;
}
.recipes-1__h2 {
  color: $color--gold;
  font-weight: 700;
  font-size: 26px;
  line-height: 30px;
  @media screen and(max-width: 768px) {
    font-size: 20px;
    line-height: 24px;
  }
}
.recipes-1__ingredient {
  color: #222222;
  font-size: 18px;
  line-height: 22px;
  &:first-child {
    margin-top: 30px;
  }
  &:not(:first-child) {
    margin-top: 5px;
  }
  @media screen and(max-width: 768px) {
    font-size: 16px;
    line-height: 20px;
  }
  
}
.recipes-1__method {
  color: #222222;
  font-size: 18px;
  line-height: 22px;
  margin-top: 30px;
  @media screen and(max-width: 768px) {
    font-size: 16px;
    line-height: 20px;
  }
  
}
.recipes-1__cta {
  background: $color--red;
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 1px;
  margin: 30px 0px 15px 0px;
  padding: 15px;
  text-transform: uppercase;
  text-align: center;
  width: 180px;
}
.recipe-1__a {
  color: $color--gold;
  text-decoration: underline;
}
.recipes-1__price {
  font-size: 16px;
  color: $color--red;
}
.recipes-1__col--2 {
  height: 550px;
}
.recipes-1__img--serve {
  bottom: 0px;
  position: absolute;
  right: 0px;
  width: 160px;
  z-index: 1000;
}
.recipes-1__img--jug {
  bottom: 20px;
  position: absolute;
  width: 280px;
}
.recipes-1__img--jug--mobile {
  display: none;
  @media screen and(max-width: 768px) {
    display: block;
    position: absolute;
    right: -260px;
    top: 10px;
    width: 220px;
  }
}
.recipes-1__img--serve--mobile {
  display: none;
  @media screen and(max-width: 768px) {
    display: block;
    position: absolute;
    left: -200px;
    bottom: 100px;
    width: 180px;
  }
  @media screen and(max-width: 321px) {
    left: -140px;
    width: 130px;
  }
}
.stripes {
  margin-top: -80px;
  width: 100%;
  padding-bottom: 100px;
  @media screen and(max-width: 768px) {
    margin-top: -50px;
    padding-bottom: 50px;
  }
}
.stripe {
  background: $color--red;
  height: 7px;
  margin-top: 7px;
  width: 100%;
}
</style>